import { render, staticRenderFns } from "./PersonalCardTypeForm.vue?vue&type=template&id=20d3fec3&"
import script from "./PersonalCardTypeForm.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports